export const markerStyles = [
    '/themes/cm/images/map/map-marker-red.png'
];

export const markerInfoWindowTemplate =
    '<div class="info-window-content">' +
    '<h3>Carl Madsen</h3>' +
    '<p>184 Ponsonby Road, Ponsonby</p>' +
    '</div>';



// WEBPACK FOOTER //
// ./javascript/modules/includes/MapModuleSettings.js